<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="添加地址"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 56px;"></div>
		<van-cell-group>
			<van-field
				clearable
				v-model="form.receiverName"
				label="收件人"
				placeholder="收件人姓名"
			/>
			
			<van-field
				clearable
				type="tel"
				v-model="form.receiverPhone"
				label="手机号码"
				placeholder="收件人联系手机号码"
			/>
			<van-field
				readonly
				:value="areaValue"
				label="地区"
				is-link 
				@click="onArea"
				placeholder="选择省/市/区"
			/>
			<van-field
				clearable
				rows="2"
				type="textarea" 
				v-model="form.receiverAddress"
				label="详细地址"
				placeholder="详细地址"
			/>
			<van-field label="默认地址">
				<template #input>
					<van-switch v-model="addressStatus" @change="onSwitch" size="20" />
				</template>
			</van-field>
		</van-cell-group>
		<div style="padding: 32px 16px 0 16px;">
		    <van-button round block type="primary" color="#2f86f6" :disabled="submitLoading" :loading="submitLoading" @click="onSubmit">提 交</van-button>
		</div>
		
		<van-popup v-model="areaShow" position="bottom" :style="{ height: '352px' }" >
			<van-area title="选择地区" :area-list="areaList" @confirm="confirmArea" @cancel="areaShow = false"/>
		</van-popup>

		
		
	</div>
</template>

<script>
	import { areaList } from '@vant/area-data';
	export default {
		name: 'Login',
		data() {
			return {
				areaShow : false,
				areaList,
				areaValue : "",
				form : {
					receiverProvince : '',
					receiverCity : '',
					receiverRegion : "",
					addressStatus : 0
				},
				addressStatus : false,
				submitLoading : false
				
			}
		},
		mounted() {
			this.addressStatus = this.form.addressStatus > 0;
		},
		methods: {
			onArea(){
				this.areaShow = true;
			},
			confirmArea(d){
				this.areaValue = d[0].name +"/"+ d[1].name +"/"+d[2].name;
				this.form.receiverProvince = d[0].name;
				this.form.receiverCity = d[1].name;
				this.form.receiverRegion = d[2].name;
				this.areaShow = false;
			},
			onSwitch(val){
				this.form.addressStatus = val ? 1 : 0;
			},
			
			onSubmit(){
				if( !this.form.receiverName ){
					this.$toast('请输入姓名');
					return false;
				}
				if( !this.form.receiverPhone ){
					this.$toast('请输入手机号码');
					return false;
				}
				if (!(/^1[3456789]\d{9}$/.test(this.form.receiverPhone))) {
				  this.$toast('手机号格式错误');
				  return false;
				}
				if( !this.form.receiverRegion ){
					this.$toast('请选择地区');
					return false;
				}
				if( !this.form.receiverAddress ){
					this.$toast('请输入详细地址');
					return false;
				}
				
				this.submitLoading = true;
				this.$post('/gtb/home/addInvoiceReceiverInfo.html', this.form ).then(res=>{
					this.submitLoading = false;
					if( res.success ){
						this.$toast.success(res.msg);
						this.$router.go(-1);
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch((res) => {
					this.submitLoading = false;
				});
				
			}
		},
	}
</script>
<style scoped>

</style>
